import sessionUtil from '@/plugins/sessionUtil'
// 设置导航历史记录
export function deleteRecrdData() {
  sessionUtil.delSession('recrdData')
}
export function getRecrdData() {
  return sessionUtil.getSession('recrdData')
}

export function setRecrdData(recrdData) {
  sessionUtil.setSession('recrdData', recrdData, 0)
}



// WEBPACK FOOTER //
// ./src/plugins/oauth.js